import { render, staticRenderFns } from "./AppPogodaKlimat.vue?vue&type=template&id=233b47ee&"
import script from "./AppPogodaKlimat.vue?vue&type=script&lang=js&"
export * from "./AppPogodaKlimat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports